// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.element-handle .v-icon.v-icon.v-icon--link {\n  cursor: move !important;\n}\n", ""]);
// Exports
module.exports = exports;
